<template>
  <div>
    <GChart :settings="{ packages: ['corechart', 'controls'] }" style="display: none" type="LineChart" @ready="onChartReady" />
    <div id="chart-container" class="row">
      <div id="moat-trends-chart" class="moat-trends col-12">
        <div id="moat-trends-title-and-chart" class="title-and-chart">
          <div class="title-and-chart-left">
            <div class="chart-title-container" v-show="this.$parent.getDisplayView() && getDisplayView()">
              <h4 class="text-primary">
                Moat Trends
                <smart-center-link page="Moats" location="Moat Trends" />
              </h4>
            </div>
            <chart-legend
              :class="getLegendClass('pt-4 pb-3')"
              height="auto"
              :direction="'vertical'"
              :width="'auto'"
              location="Moat By Trend"
              :elements="$parent.legendElements"
              @redraw="showOrHideElements"
            >
            </chart-legend>
          </div>
          <div class="buttons-and-chart">
            <chart-buttons
              :display="this.$parent.getDisplayView() && getDisplayView()"
              :tooltip-configuration="snapChartTooltipConfig"
              :snap-container-id="'moat-trends-title-and-chart'"
              :container-id="'moat-trends-chart'"
              :report-page-type-name="'Chart - Moat Trends'"
              :insight-modal-id="'moat-trends-chart'"
              :text-direction="this.$parent.textDirection"
            >
            </chart-buttons>
            <div id="moat-trends" class="chart"></div>
          </div>
          <div v-show="this.$parent.getDisplayView() && getDisplayView()" class="vertical-line left"></div>
          <div v-show="this.$parent.getDisplayView() && getDisplayView()" class="vertical-line right"></div>
        </div>
      </div>
      <div class="col-12">
        <div v-show="this.$parent.getDisplayView() && getDisplayView()" id="moat-trends-data-container" class="chart-data">
          <chart-data-table
            :data-container-id="'moat-trends-data-container'"
            :container-id="'moat-trends'"
            :report-page-type-name="'Table - Moat Trends'"
            :insight-modal-id="'moat-trends-table'"
            :chart-data="this.table.data"
            :row-start-position="6"
            :column-defs="this.chart.columnDefs"
            :table-class="'table display row-border table-hover'"
            :table-width="'auto'"
            :table-title="this.table.title"
          ></chart-data-table>
        </div>
      </div>
    </div>
    <insights
      ref="insightsChart"
      :modal-name="'moat-trends-chart'"
      :report-page-type-name="'Chart - Moat Trends'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
    <insights
      ref="insightsTable"
      :modal-name="'moat-trends-table'"
      :report-page-type-name="'Table - Moat Trends'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
  </div>
</template>
<script>
import $ from "jquery";
import ChartCompanyMixins from "../../../mixins/ChartCompanyMixins.vue";
import ChartLegend from "../../../components/chart/ChartLegend.vue";
import ChartButtons from "../../../components/chart/ChartButtons.vue";

import ReportService from "../../../services/report.service";
import ChartService from "../../../services/chart.service";
import ErrorService from "../../../services/error.service";
import AdminService from "../../../services/admin.service";
import TableService from "../../../services/table.service";
import smartresize from "../../../services/smartresize";

export default {
  name: "MoatTrend",
  mixins: [ChartCompanyMixins],
  components: { ChartLegend, ChartButtons },
  data() {
    return {
      title: "Moat Trends",
      pageNumber: 5,
      periodPrefix: "Start",
      primaryChart: {},
      table: {
        id: "",
        data: {},
        title: '<h4 class="text-primary">Moat Trends</h4>'
      },
      redrawAdditionalWidgets: true,
      moatChartOptions: {}
    };
  },
  props: {
    chartData: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  methods: {
    displayInsights(insightModalId, reportPageTypeName) {
      if (reportPageTypeName == "Chart - Moat Trends") {
        this.$refs.insightsChart.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsChart.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Table - Moat Trends") {
        this.$refs.insightsTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsTable.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      }
    },
    onChartReady(chart, google) {
      this.chartsLib = google;
      this.primaryChart = new google.visualization.ChartWrapper({
        chartType: "LineChart",
        containerId: "moat-trends"
      });
    },
    async processChartData() {
      try {
        if (this.$parent.$refs.chartCriteria.$data.textDirection != ""){
          this.$parent.textDirection = this.$parent.$refs.chartCriteria.$data.textDirection;
        }
        let moatData = JSON.parse(JSON.stringify(this.chartData[0]));
        this.redrawAdditionalWidgets = true;
        this.chart = ChartService.getChartAttributes("Moat Trends");
        let otherData = moatData["otherData"];
        this.$parent.legendElements = otherData["legend"];
        let companyColorList = otherData["companyColorList"];
        TableService.setCompanyColorList(companyColorList);
        ChartService.setMainClientXStyle(companyColorList[0].color, $("#chart-container"));
        let breakPointList = otherData["breakPointList"];
        ChartService.setVerticalLineBreakPoints(breakPointList);
        let dynamicChartOptions = moatData["options"];
        let containerId = moatData["containerId"];
        let chartOptions = ChartService.getChartOptions(containerId);
        $.extend(chartOptions, dynamicChartOptions);
        let vAxisForMetric = otherData["vAxisForMetric"];
        $.extend(chartOptions.vAxes[1], vAxisForMetric);
        let usePercentage = otherData["usePercentage"];
        let useCurrency = otherData["useCurrency"];
        if (useCurrency == true || useCurrency == "true") {
          $.extend(this.chart.columnDefs[2], TableService.getDollarTableAttribute([1], "dt-right chart-light-green", 75, 2));
        } else if (usePercentage == false) {
          $.extend(this.chart.columnDefs[2], TableService.getNumericTableAttribute([1], "dt-right chart-light-green", 75, 2));
        } else {
          $.extend(this.chart.columnDefs[2], TableService.getPercentTableAttribute([1], "dt-right chart-light-green", 75, 2));
        }
        this.$parent.setChartResults(moatData.companyList);
        this.$parent.$data.criteriaResultsList = AdminService.removeByName(moatData.criteriaList, "Competitor");
        this.table.id = containerId;
        this.table.data = moatData;
        this.moatChartOptions = JSON.parse(JSON.stringify(chartOptions));
        this.moatChartOptions = ChartService.setHAxisFormat(this.$parent.textDirection, this.moatChartOptions);
        await ChartService.paintChart(this.primaryChart, containerId, chartOptions, moatData, this);
        this.resetLegendElements();
        this.$root.$emit("check-number-of-responses");
        this.setDisplayView(true);
        this.$parent.setDisplayView(true);
        this.$root.processServerResponse();
      } catch (err) {
        ErrorService.processException("CompetitiveTrends.displayChartCallback", err, "chart", this);
      }
    },
    async showOrHideElements(element) {
      if (element.visible == true) {
        this.moatChartOptions.series[element.seriesNumber].lineWidth = 5;
      } else {
        this.moatChartOptions.series[element.seriesNumber].lineWidth = 0;
      }
      this.prePaintChart(false);
    },
    async smartRedrawChart(generatedChart) {
      generatedChart.find(".vertical-line").remove();
      this.prePaintChart(true);
    },
    async prePaintChart(redrawWidgets) {
      this.redrawAdditionalWidgets = redrawWidgets;
      let moatData = JSON.parse(JSON.stringify(this.chartData[0]));
      await ChartService.paintChart(this.primaryChart, this.table.id, this.moatChartOptions, moatData, this);
    },
    async setXAxisTextDirection(containerId, direction){
      if (typeof this.$parent.$refs.chartCriteria != "undefined"){
          this.$parent.$refs.chartCriteria.setTextDirection(direction);
      }      
      this.moatChartOptions = ChartService.setHAxisFormat(direction, this.moatChartOptions);
      this.$parent.textDirection = direction;
      this.prePaintChart(true);
    },
    postPaintChart(primary_chart, containerId, options, dataTable) {
      var chartContainer = $("#" + containerId);
      let chartInterface = primary_chart.getChartLayoutInterface();

      let chartBase = {
        width: 0,
        left: 1,
        top: 5,
        height: chartInterface.getChartAreaBoundingBox().height
      };
      let verticalLine = {
        top: chartBase.top,
        height: chartBase.height,
        left: chartBase.left
      };
      let gap = (chartInterface.getXLocation(1) - chartInterface.getXLocation(0)) / 2;
      let moatTrendVerticalLineIndex = ChartService.getVerticalLineBreakPoints();
      //Draw the special symbols X and -
      let className = "vertical-line";
      for (var index = 0; index < dataTable.getNumberOfRows(); index++) {
        if (this.redrawAdditionalWidgets == true && typeof moatTrendVerticalLineIndex != "undefined" && moatTrendVerticalLineIndex.includes(index)) {
          let xPos = chartInterface.getXLocation(index) + verticalLine.left + gap;
          chartContainer.append(ChartService.paintVerticalLine(verticalLine.top, xPos, verticalLine.height, className));
        }
      }
      let horizontalLine = {
        top: chartInterface.getYLocation(10),
        left: chartInterface.getChartAreaBoundingBox().left
      };
      let chartWidth = chartInterface.getChartAreaBoundingBox().width;
	    chartContainer.append(ChartService.paintHorizontalLine(horizontalLine.top, horizontalLine.left, chartWidth, "moat-level-1-horizontal-line"));     
      horizontalLine.top = chartInterface.getYLocation(35);
	    chartContainer.append(ChartService.paintHorizontalLine(horizontalLine.top, horizontalLine.left, chartWidth, "moat-level-2-horizontal-line"));     
      horizontalLine.top = chartInterface.getYLocation(75);
	    chartContainer.append(ChartService.paintHorizontalLine(horizontalLine.top, horizontalLine.left, chartWidth, "moat-level-3-horizontal-line"));     
      horizontalLine.top = chartInterface.getYLocation(90);
	    chartContainer.append(ChartService.paintHorizontalLine(horizontalLine.top, horizontalLine.left, chartWidth, "moat-level-4-horizontal-line"));     
      


      let parentContainer = chartContainer.parent();
      parentContainer.parent().addClass("chart-wrapper");
      this.saveReportPage("moat-trends");
    },
    async saveReportPage(containerId) {
      if (this.$parent.clientChart.clientChartId != 0  && this.isGenerateReportRunning()) {
        let copyChart = $("#" + containerId).clone();
/*        
        let reportPageChartContent = copyChart
          .wrapAll("<div>")
          .parent()
          .html();
*/
        let reportPageChart = $("#" + containerId);
        let reportPageChartObject = reportPageChart[ 0 ];
        let reportPageChartContent = await this.createChartImage(reportPageChartObject, false, true); 

        await ReportService.saveReportPage(reportPageChartContent, "Chart - Moat Trends", this.$parent.clientChart, this.saveReportPageCallback, this);
        await ReportService.saveReportPage(
          this.getReportTableContentByTable("dataTableVertical_" + containerId + "_wrapper"),
          "Table - Moat Trends",
          this.$parent.clientChart,
          this.saveReportPageCallback,
          this
        );
      }
    },
    saveAllReportPages() {
      this.saveReportPage("moat-trends");
    },
    getLegendClass: function(legendClass) {
      if (this.$parent.getDisplayView() && this.getDisplayView()) {
        legendClass += " visible";
      } else {
        legendClass += " invisible";
      }
      return legendClass;
    }
  },
  destroyed() {},
  computed: {},
  mounted() {
    let vm = this;
    $(window).smartresize(function() {
      if (vm.$parent.isMoatTrend) {
        vm.smartRedrawChart($("#moat-trends"));
      }
    });
  },
  created() {},
  watch: {
    chartData: function() {
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try{this.primaryChart.getChart().clearChart();} catch(e){}      
      if (this.$parent.isMoatTrend) {
        this.processChartData();
      } else {
        this.setDisplayView(false);
      }
    }
  }
};
</script>
